export default __webpack_public_path__ + "static/images/80b8e9471f7d8945343759e0fd557839.png";